import axios from "axios";

const baseUrl = "/api/PensionCalculator";
export class PensionAgeCalculatorService {
    private readonly _sourceFileId: string;

    constructor(sourceFileId: string) {
        this._sourceFileId = sourceFileId;
    }

    public getPensionTargets(birthYear: number, birthMonth: number) {
        const params = {
            birthMonth,
            birthYear,
            sourceFileId: this._sourceFileId,
        };
        const url = baseUrl + "/GetPensionTargets/";
        return axios.get<IPensionAgeCalculationResult>(url, { params }).then((result) => result.data);
    }
}

export interface IMonthYear {
    year: number;
    month: number;
}

export interface IAge {
    months: number;
    years: number;
}

export interface IPensionAgeCalculationResult {
    birthTime: IMonthYear;
    lowestDate: IMonthYear;
    targetDate: IMonthYear;
    latestDate: IMonthYear;
    lowestAge: IAge;
    targetAge: IAge;
    maximumAge: IAge;
}
